
import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    availableRooms: [],
    check_in_date: null,
    check_out_date: null,
  };
  
  const availabilitySlice = createSlice({
    name: "availability",
    initialState,
    reducers: {
      setAvailabilityData: (state, action) => {
        state.availableRooms = action.payload.rooms;
        state.check_in_date = action.payload.check_in_date;
        state.check_out_date = action.payload.check_out_date;
      },
      clearAvailabilityData: (state) => {
        state.availableRooms = [];
        state.check_in_date = null;
        state.check_out_date = null;
      },
    },
  });

export const { setAvailabilityData, clearAvailabilityData } = availabilitySlice.actions;
export default availabilitySlice.reducer;
